const CalenderStyles = (theme) => ({
  eventMainContainer: {
    paddingTop: "20px",
    paddingBottom: 0,
    fontSize: "14px",

    "& .MuiGrid-spacing-xs-2 > .MuiGrid-item": {
      padding: "4px",
    },
    "& .MuiInputBase-input, & .MuiFormLabel-root": {
      fontSize: "12px",
    },
  },
  buttonActive: {
    backgroundColor: "#02c1c6 !important",
    color: "white !important",
    padding: "4px 8px  !important",
    fontSize: "1em !important",
    borderRadius: "8px !important",
    "&:disabled":{
      boxShadow: "0px 2px 2px 0px rgb(0 0 0 / 75%)",
      backgroundColor: "#536175 !important",
      outline: "none",
      border: "none",
      boxSizing: "border-box",
    }
  },
  popupCalenderHeader: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: "#02c1c6 !important",
    padding: "8px",
    zIndex:"99 !important",

    display: "flex",
    justifyContent: "space-between",
    "& header": {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "start",
      fontWeight: 700,
      fontSize: "1.5rem",
      color: "white",
    },
  },
  radioButtonContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "row",
    textAalign: "center",
    "& > h6": {
      marginBottom: 0,
    },
    "& >div > .MuiFormControlLabel-label": {
      fontWeight: 700,
    },
    "& >div > .MuiFormControlLabel-root": {
      marginRight: "32px",
      marginBottom: 0,
    },
  },
  
  scheduleContainer: {
    height: "5rem",
  },
  topContainer: {
    borderBottom: "1px solid grey",
    "& > .MuiGrid-spacing-xs-2 > .MuiGrid-item": {
      padding: "4px !important",
    },
  },
  scheduleDates: {
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",

    margin: "1rem auto 0.8rem",
  },
  datesContainer: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    textAlign: "center",
    marginBottom: 8,
    gap: "12px",
    "& > p": {
      marginBottom: 0,
      width: "15%",
    },
    "& > .MuiOutlinedInput-root": {
      height: "2.5rem",
      borderBottom: "none",
    },
  },
  eventNotes: {
    "& .MuiOutlinedInput-inputMultiline":{
      height:"unset !important"
    }
  }
});

export default CalenderStyles;
